import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {DocumentCommentDto} from "../document-comment.dto";

export class SearchCommentRes extends SearchResultDto {

  public override readonly items: SearchCommentItem[] = [];

  constructor(init?: Partial<SearchCommentRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchCommentItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchCommentItem extends DocumentCommentDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchCommentItem>) {
    super(init);
    Object.assign(this, init);
  }
}
